import React from 'react';
import { Select, MenuItem, FormControl, Box } from '@mui/material';
import { useAuth } from '../Auth';
import { useNavigate } from 'react-router-dom';

export default function TenantSwitcher() {
    const { user, globalTenants, switchTenant } = useAuth();
    const navigate = useNavigate();
    const currentTennant = user?.tenant_id || '';
    const isTenantLoaded = globalTenants.some(t => t.id === currentTennant);
   
    const handleSwitch = async (event) => {
        const result = await switchTenant(event.target.value);
        if (result?.success) {
            navigate(result.target);
        }
    };

    
    if (user?.role !== 'superuser') return null;

    return (
        <Box sx={{ minWidth: 200 }}>
            <FormControl size="small" fullWidth>
                <Select
                    value={isTenantLoaded ? currentTennant : ""}
                    onChange={handleSwitch}
                    displayEmpty
                    className="tenant-switcher-select"
                >
                    <MenuItem value="">
                        <em>Global View (All Tenants)</em>
                    </MenuItem>

                    {Array.isArray(globalTenants) && globalTenants.length > 0 ? (
                        globalTenants.map((tenant) => (
                            <MenuItem key={tenant.id} value={tenant.id}>
                                {tenant.name}
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem disabled value="">
                            Loading tenants...
                        </MenuItem>
                    )}
                </Select>
            </FormControl>
        </Box>
    );
}